import React from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import "swiper/css"
import "swiper/css/pagination"

import { mySwiper, swiperSlide } from "./section.module.css"
import { FreeMode, Autoplay, Pagination, Navigation } from "swiper"
import Card from "../card/Card"

const Section = ({ category, products, image }) => {
  const title = category.title
  const slug = `/${category?.category?.slug?.current}/${category?.slug?.current}`
  return (
    products.length > 0 && (
      <div className="py-6">
        {image && (
          <div className="flex justify-center pb-6">
            <GatsbyImage
              image={image.asset.gatsbyImageData}
              alt={title}
              objectFit="fill"
              className="object-center object-contain max-h-32 mx-auto sm:max-h-40  2xl:max-h-72 2xl:min-h-40"
            />
          </div>
        )}
        <div className="flex justify-between">
          <h2 className="pl-3 text-2xl font-bold underline">
            {" "}
            <Link to={slug}>{title}</Link>{" "}
          </h2>
          <h4 className="pr-3 text-xl font-bold underline">
            {" "}
            <Link to={slug}>View all</Link>{" "}
          </h4>
        </div>
        <div>
          <Swiper
            freeMode={true}
            loop={true}
            slidesPerView={2}
            loopedSlides={2}
            spaceBetween={20}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            breakpoints={{
              768: {
                slidesPerView: 2,
                loopedSlides: 2,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 3,
                loopedSlides: 3,
                spaceBetween: 20,
              },
              1440: {
                slidesPerView: 6,
                loopedSlides: 6,
                spaceBetween: 20,
              },
            }}
            modules={[FreeMode, Pagination, Autoplay, Navigation]}
            className={mySwiper}
          >
            {products.map((product, index) => {
              return (
                <SwiperSlide key={index} className={swiperSlide}>
                  <Card product={product} />
                </SwiperSlide>
              )
            })}
          </Swiper>
        </div>
      </div>
    )
  )
}

export default Section
